import React, { useEffect, useState } from "react";
import useHttp from "../../../hooks/use-http";
import Pagination from "../../../components/Pagination";
import { Modal as AntModal } from "antd";
import { toast } from "react-toastify";
const AccountDetailList = (props) => {
  const { addForm, update } = props;
  const [data, setData] = useState([]);
  const [itemsPerPage] = useState(10);
  const { sendRequest: getUser } = useHttp();

  const { sendRequest: getDataList } = useHttp();
  const [allData, setAllData] = useState([]);

  const { sendRequest: deleteHolidays } = useHttp();

  const deleteOperation = (e, data) => {
    e.preventDefault();
    AntModal.confirm({
      title: "Confirm Deletion",
      content: "Are you sure you want to delete this Holidays detail?",
      onOk() {
        const updatedApproveData = {
          ...data,
          status: 0,
        };

        deleteHolidays(
          {
            url: `/api/accountDetail?orgId=${localStorage.getItem("orgId")}`,
            method: "PUT",
            body: updatedApproveData,
          },
          (data) => {
            toast.success("Data deleted successfully");
            FillDetail();
          }
        );
      },
      onCancel() {},
    });
  };

  const FillDetail = () => {
    getDataList(
      {
        url: `/api/accountDetail?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        if (res) {
          setData(res);
          setAllData(res);
        }
      }
    );
  };

  useEffect(() => {
    FillDetail();
  }, [getDataList]);

  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleSearch = (e) => {
      var filetrtext = e.target.value.trim().toLowerCase();
    console.log(filetrtext);

    var filterdata = allData.filter(
      (item) =>
      item?.accountName?.includes(filetrtext)
        // item?.accountGroupName?.includes(filetrtext) ||
        // item?.accountGroupcode?.includes(filetrtext) ||
        // item?.accountHead?.includes(filetrtext) ||
        // item?.accountSubGroupName?.includes(filetrtext) ||
        // item?.accountSubGroupCode?.includes(filetrtext) ||
        // item?.accountCode?.includes(filetrtext) ||
        // item?.accountName?.includes(filetrtext)
    );

   setData(filterdata); 
                                
setCurrentPage(1);
    setCurrentPage(0);
  };

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          <div className="col-6">
            <label className="card-title mx-2 my-3">
              {" "}
              &nbsp; &nbsp;Account Detail{" "}
            </label>{" "}
          </div>
          <div className="col-3"> </div>
          <div className="col-3">
            <button
              type="button"
              className="btn  btn-primary mx-2 my-2"
              onClick={() => {
                addForm(true);
                props.update(false);
              }}
            >
              Add Account Detail  
            </button>
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-4"> </div>
                      <div className="col-5"> </div>

                      <div className="col-3">
                        {" "}
                        <input
                          type="text"
                          name="q"
                          className="form-control"
                          onKeyUp={(e) => {
                            handleSearch(e);
                          }}
                          placeholder="Search..."
                        />{" "}<br/>
                      </div>
                    </div>
                    <div className="row">
                      <table className="table table-bordered text-center">
                        <thead>
                          <tr>
                            <th> Account Name</th>
                            <th> Account Code</th>

                            <th> Account Subgroup Name</th>
                            <th> Account Subgroup Code</th>
                            <th> Account Group Name</th>
                            <th> Account Group Code</th>
                            <th>Account Head</th>
                            <th>Status</th>
                            <th>Edit</th>
                            <th>Delete</th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentItems &&
                            currentItems.map((x, i) => (
                              <tr key={i}>
                                <td>{x.accountName}</td>
                                <td>{x.accountCode}</td>
                                <td>{x.accountSubGroupName}</td>
                                <td>{x.accountSubGroupCode}</td>
                                <td>{x.accountGroupName}</td>
                                <td>{x.accountGroupCode}</td>
                                <td>{x.accountHead}</td>

                                <td>
                                  {x.status == 1 ? "Active" : "In-Active"}
                                </td>
                                <td>
                                  <button className="btn">
                                    {" "}
                                    <i className="fas fa-edit"></i>
                                  </button>
                                </td>
                                <td>
                                  <button
                                    className="btn"
                                    onClick={(e) => deleteOperation(e, x)}
                                  >
                                    {" "}
                                    <i className="fas fa-trash"></i>
                                  </button>
                                </td>
                              </tr>
                            ))}
                        </tbody>

                        {/* <tbody>
                        {currentItems &&
                          currentItems.map((itm, i) => {
                            return (
                              <tr key={i} className="tablerowview">
                                <td>
                                  {" "}
                                  <img
                                    src={`${process.env.REACT_APP_FILE_URL}${itm.profileurl}`}
                                    className="user-image img-circle"
                                    width="60"
                                    height="60"
                                    alt="User Image"
                                  />
                                </td>
                                <td>{itm.employeeName}</td>
                                <td>{itm.employeeCode}</td>
                                <td>{itm.designationName}</td>
                                <td>{itm.departmentName}</td>
                                <td>{itm.workEmailId}</td>
                                <td>{itm.useCase}</td>
                                <td>
                                  <button
                                    onClick={() => {
                                      props.addForm(true);
                                      props.update(itm);
                                    }}
                                    className="btn"
                                  >
                                    <i className="fas fa-edit"></i> Edit
                                  </button>
                                </td>
                              </tr>
                            );
                          })}
                      </tbody> */}
                      </table>
                    </div>
                  </div>
                  {/* /.card-body */}
                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default AccountDetailList;
